module.exports = __webpack_public_path__ + "static/fish-dish-f1747da533c1bec7ee00988487fb1009.jpg";